import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  div: {
    backgroundColor: "#000000",
    padding: '16px',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divButton: {
    width: "100%",
    display: "flex",
    justify: "center",
    alignItems: "center",
    marginTop: "100px",
    marginBottom: "24px",
  },
  divTitle: {
    width: "100%",
    display: "flex",
    marginTop: "12px",
    marginLeft: "12px",
    marginBottom: "24px",
  },
  divgroupTypeAndPrice: {
    width: "100%",
    display: "flex",
    justify: "center",
    alignItems: "center",
    marginTop: "12px",
    marginLeft: "12px",
    marginBottom: "24px",
  },
  disableButton: {
    backgroundColor: "#F4F4F4",
    color: "#C9C9C9",
    fontSize: "20px",
    padding: "12px 60px",
    borderRadius: '6px',
    margin: "auto",
    borderWidth: "0px"
  },
  enableButton: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "20px",
    padding: "12px 60px",
    borderRadius: '6px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
    boxShadow: theme.customShadows.widgetBlack,
  },
  divColumn: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    ['@media (max-width:800px)']: {
      gridTemplateColumns: '1fr',
    },
    marginBottom: "24px",
  },
  input: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
  },
  textBorder: {
    "&:before": {
      borderBottomColor: '2px solid #F4F4F4'
    },
    "&:after": {
      borderBottomColor: '2px solid #000000'
    },
    "&:hover:before": {
      borderBottomColor: '2px solid #000000',
    },
  },
  titleStyle: {
    fontWeight: '500',
    fontSize: "28px",
    color: "#999696",
  },
  label: {
    display: 'flex',
    fontWeight: '500',
    padding: '10px',
    minHeight: '40px',
    color: "#FFFFFF",
  },
  divLabel: {
    display: "flex",
    height: "40px",
    justify: 'center',
    alignItems: 'center'
  },
  root: {
    display: 'block',
    flexWrap: 'wrap',
  },
  formControl: {
    width: '85%',
    color: '#FFFFFF'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  inputSelect: {
    backgroundColor: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
  },
  divCard: {
    backgroundColor: "#000000",
    padding: '16px',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  searchIcon: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
  },
  divActionButton: {
    height: '40px',
    width: '40px',
    backgroundColor: "#FFFFFF",
    marginLeft: '20px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  marginAuto: {
    margin: "auto"
  },
  divActionButtonDisable: {
    height: '40px',
    width: '40px',
    backgroundColor: "#F4F4F4",
    marginLeft: '20px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  activeButtonDisable: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: '#908F8F'
  },
  loginPage: {
    display: "flex",
    justify: "center",
    alignItems: "center",
    margin: "auto",
    marginTop: "125px",
    marginBottom: "125px",
  },
  loginLoader: {
    display: "flex",
    justify: "center",
    alignItems: "center",
    margin: "auto"
  },
  divGroupType: {
    width: "100%",
    display: "flex",
    marginLeft: "12px",
    marginBottom: "48px",
  },
  formControlGroupType: {
    width: '85%',
  },
  partnerTypeTitleStyle: {
    fontWeight: '300',
    fontSize: "24px",
    color: "#999696",
  },
  priceTitleStyle: {
    fontWeight: '300',
    fontSize: "24px",
    color: "#FFFFFF",
  },
  divButtonAdditionalPartners: {
    width: "100%",
    display: "flex",
    justify: "center",
    alignItems: "center",
    marginTop: "50px",
    marginBottom: "24px",
  },
  divider: {
    width: "100%",
    height: "2px",
    display: "flex",
    justify: "center",
    alignItems: "center",
    marginTop: "60px",
    marginBottom: "60px",
    backgroundColor: "#999696",
  },
  divPayTitle: {
    width: "100%",
    display: "flex",
    marginTop: "6px",
    marginLeft: "12px",
    marginBottom: "6px",
  },
  payTitleStyle: {
    fontWeight: '500',
    fontSize: "28px",
    color: "#FFFFFF",
  },
  inputPay: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '28px',
  },
  inputPaySale: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '20px',
  },
  payGroupStyle: {
    fontWeight: '500',
    fontSize: "20px",
    color: "#FFFFFF",
  },
  payGroupStyleBold: {
    fontWeight: '600',
    fontSize: "20px",
    color: "#FFFFFF",
  },  
  rowButtons: {
    display: 'flex',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  },
  enableButtonProfitLeft: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "12px",
    padding: "4px 10px",
    borderBottomLeftRadius: '3px',
    borderTopLeftRadius: '3px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
  },
  enableButtonProfitRight: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "12px",
    padding: "4px 10px",
    borderBottomRightRadius: '3px',
    borderTopRightRadius: '3px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
  },
  enableButtonProfit: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "12px",
    padding: "4px 10px",
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
  },
  selectedButtonProfitLeft: {
    backgroundColor: "#FF0000",
    color: "#FFFFFF",
    fontSize: "12px",
    padding: "4px 10px",
    borderBottomLeftRadius: '3px',
    borderTopLeftRadius: '3px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
  },
  selectedButtonProfitRight: {
    backgroundColor: "#FF0000",
    color: "#FFFFFF",
    fontSize: "12px",
    padding: "4px 10px",
    borderBottomRightRadius: '3px',
    borderTopRightRadius: '3px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
  },
  selectedButtonProfit: {
    backgroundColor: "#FF0000",
    color: "#FFFFFF",
    fontSize: "12px",
    padding: "4px 10px",
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
  },
  divHeader: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    marginBottom: '24px',
  },
  searchDivFullWidthWithoutShadow: {
    height: '44px',
    width: '100%',
    backgroundColor: "#FFFFFF",
    padding: '6px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
  },
  inputSearchFinger: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    padding: '1px',
    width: '100%',
    outlineColor: "#FFFFFF"
  },
  divActionButton: {
    height: '40px',
    width: '40px',
    backgroundColor: "#FFFFFF",
    marginLeft: '20px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
  },
  iconAcctionInventory: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  tableServices: {
    "& .MuiTableCell-head": {
      backgroundColor: "#FFFFFF",
      color: "#000000",
      marginTop: "20px",
      marginBottom: "20px",
      fontSize: "16px",
      borderBottom: 'none',
    },
  },
  tableServicesTextStyle: {
    color: "#000000",
    fontSize: "16px",
    borderBottom: 'none',
  },
  textBorderMembership: {
    "&:before": {
      borderBottomColor: '2px solid #F4F4F4'
    },
    "&:after": {
      borderBottomColor: '2px solid #000000'
    },
    "&:hover:before": {
      borderBottomColor: '2px solid #000000',
    },
  },
  inputMembership: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    padding: '8px',
    width: '35%',
    fontSize: '18px',
  },
  divDate: {
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    color: "#000000",
  },
  labelDate: {
    display: 'flex',
    fontWeight: '500',
    padding: '10px',
    minHeight: '40px',
    color: "#000000",
  },
  inputDate: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
    marginBottom: '4px'
  },
  inputEntry: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '100%',
    fontSize: '18px',
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  cardPartnerGroup: {
    display: "flex",
    backgroundColor: "#000000",
    borderRadius: "4px",
    marginBottom: "40px",
    height: "100px",
    width: "320px",
    marginRight: "20px",
    justify: "center",
    alignItems: "center",
  },
  cardLabel: {
    color: "#FFFFFF",
    height: "100%",
    width: "70%",
    textAlign: "center",
    justify: "center",
    alignItems: "center",
    cursor: 'pointer',
  },
  inputPayGroup: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '100%',
    fontSize: '18px',
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  divAddButton: {
    height: '50px',
    width: '50px',
    backgroundColor: "#FFFFFF",
    marginLeft: '24px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  tableRowStyleTitle: {
    color: "#FFFFFF",
    fontSize: "20px",
    borderBottom: 'none',
  },
  rootTable: {
    "& .MuiTableCell-head": {
      color: "white",
      marginTop: "20px",
      marginBottom: "20px",
      fontSize: "16px",
      borderBottom: 'none',
    },
  },
  textSuccess: {
    fontSize: "16px",
    color: theme.palette.success.main,
  },
}));
